export default class AddressDropDownViewModel {
    public display: string | undefined = undefined;
    public index: number | undefined = undefined;
}